import { FunctionComponent } from "react";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import { ListPerson } from "@/pages/Private/pages/List/schema/list";
import { classNames } from "@/utils/classNames";

export const JobTitle: FunctionComponent<{
	row: ListPerson;
	// Optional hover override (e.g. the LinkedIn headline on company-enrich
	// results, PREC-3669); defaults to the job title itself.
	tooltipContent?: string | null;
	// Compact lead card (PREC-3850): 12px type scale instead of the 14px list-card default.
	compact?: boolean;
}> = ({ row, tooltipContent, compact = false }) => {
	const jobTitle = row.prospect?.jobTitleToSeniority?.jobTitle;

	return (
		<div
			className={classNames(
				"text-left flex flex-col gap-1 w-full",
				compact ? "text-xs" : "text-sm"
			)}
		>
			<Tooltip content={tooltipContent ?? jobTitle}>
				<button className="text-ellipsis text-status-info overflow-hidden max-w-[100%] cursor-pointer whitespace-nowrap">
					{jobTitle}
				</button>
			</Tooltip>
		</div>
	);
};
